var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"omise-footer"}},[_c('span',{staticClass:"text--secondary"},[_vm._v("Secured by ")]),_c('img',{attrs:{"srcSet":_vm.utility.getImgSrcSet('logo_omise', 'png', true)}})])}
var staticRenderFns = []

export { render, staticRenderFns }